import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/axios';
import { API_ROUTES } from '@/constants/routes';
import type { WhatsappHistory } from '@/types/outreach';

interface HistoryResponse {
  items: WhatsappHistory[];
  total: number;
}

export const useWhatsappHistory = (search: string, period: string, offset: number) => {
  return useQuery<HistoryResponse>({
    queryKey: ['whatsappHistory', search, period, offset],
    queryFn: async () => {
      const params: Record<string, string | number> = {
        offset,
        limit: 10,
      };
      if (search) params.search = search;
      if (period !== 'all') params.period = period;
      const { data } = await api.get(API_ROUTES.whatsappHistory, { params });
      return data;
    },
  });
};
